export enum AchievementType {
	Mission = 1,
	Badge = 2,
}
